var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"background-color":"background lighten-1"}},[_c('v-tabs-slider'),_c('v-tab',{attrs:{"to":{name: 'Login Logs'}}},[_vm._v("Login Logs")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }